<script setup lang="ts">
import CarwowLogo from './CarwowLogo.vue'

withDefaults(defineProps<{
  showLogo?: boolean
}>(), {
  showLogo: true
})
</script>

<template>
  <div class="bx-carwow__cta">
    <span>zum Angebot</span>
    <CarwowLogo v-if="showLogo" />
  </div>
</template>
